"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabState = void 0;

var _react = require("react");

var useTabState = function useTabState() {
  var defaultIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref = (0, _react.useState)(defaultIndex),
      _ref2 = _slicedToArray(_ref, 2),
      activeIndex = _ref2[0],
      setActiveIndex = _ref2[1];

  var handleChange = function handleChange(index) {
    setActiveIndex(index);
  };

  return {
    activeIndex: activeIndex,
    handleChange: handleChange
  };
};

exports.useTabState = useTabState;